import { render } from "./DataStatusBumil.vue?vue&type=template&id=6b9bd4b6"
const script = {}

import exportComponent from "E:\\WEB-APPS\\gizkia\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__